module.exports = __webpack_public_path__ + "img/387.1df7d9cf.jpg";